import {
  containerStyle,
  disclaimerStyles,
  headerStyles
} from './pricing-display.styles';
import { BillingCycleSelector, ProductSummary, PriceTotal } from './components';
import { useModuleProps } from '../../module-props';

const PricingDisplay = ({
  contactSalesTeamURL
}: {
  contactSalesTeamURL: string;
}) => {
  const { estimateLabel, pricingDisclaimerLabel } = useModuleProps();

  const linkURL =
    '/' +
    (document.documentElement.lang.split('-')[0] || '') +
    contactSalesTeamURL;

  return (
    <div>
      <div css={containerStyle}>
        <h3 css={headerStyles}>{estimateLabel}</h3>
        <BillingCycleSelector />
        <ProductSummary />
        <PriceTotal contactSalesUrl={linkURL} />
      </div>
      <div css={disclaimerStyles}>{pricingDisclaimerLabel}</div>
    </div>
  );
};

export default PricingDisplay;
